exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter {\n    width: 75px;\n    margin-right: 20px;\n    height: 27px;\n    font-size: 17px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accounts/metrics/accounts-metrics.component.css
// module id = ../../../../../src/app/accounts/metrics/accounts-metrics.component.css
// module chunks = main